import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import Select from 'ol/interaction/Select';
import {click} from 'ol/events/condition';
import {getCenter} from 'ol/extent';
import Overlay from 'ol/Overlay';

import {getLayerByName} from '@api/map2d';

let assetsUrl=window.location.protocol+'//' + window.location.host; // 静态资源的地址

/**
 * 开度信息
 */
export default class Valve{
    constructor(mainmap,dbname){
        this.mainmap=mainmap;
        this.dbname=dbname;
        this.assetsUrl=window.location.protocol+'//' + window.location.host, // 静态资源的地址
        this.layer=null;
        this.getLayer();
    }

    // 获取图层信息
    async getLayer(){
        let data=await getLayerByName(this.dbname,"valve");
        try{
            let geojsonFormat=new GeoJSON();
            let features=geojsonFormat.readFeatures(data);
            
            //绘制图层
            let vectorSource = new VectorSource({
                name:"valve_source",
                format: new GeoJSON(),
            });
            vectorSource.addFeatures(features);
            let vector = new VectorLayer({
                source: vectorSource,
                name:"valve_layer",
                zIndex:20,
                minResolution:this.mainmap.getResolution(20),
                maxResolution:this.mainmap.getResolution(12),
                style:this.layerStyle
            });

            this.layer=vector;
            this.mainmap.addLayer(vector);

            // 增加鼠标点击事件
            this.addSelectClick();
        }catch(err){
            console.log("ERROR:Valve:getLayer:获取开度图层失败");
        }
        
    }
    // 配置站点样式
    layerStyle(feature){
        let properties=feature.getProperties();
        // let type=properties.type||"virtual"; // 站点图标类型
        let label=properties.label||0;// 站点图标的旋转方向
        let src=assetsUrl+"/img/valve-315.png";

        // 设置图标的样式
        let iconStyle = new Style({
            image: new Icon({
                src: src,
                scale:0.8,
                anchor:[0.5,1],
                rotation:label/180*Math.PI
            })
        });
        return iconStyle;
    }
    // 添加鼠标点击事件
    addSelectClick(){
        let that=this;
        // select interaction working on "click"
        var selectClick = new Select({
            condition: click,
            layers:[this.layer],
            style:this.layerStyle
        });
        selectClick.on('select', function (e) {
            let selected=e.selected;
            if(selected.length>0){
                that.showContentPanel(selected[0]);
            }
        });

        this.mainmap.addInteraction(selectClick);
    }

    // 显示属性框
    showContentPanel(feature){
        let that=this;
        let realData=feature.getProperties();
        if(realData){
            //关闭颜色显示
            let overlay=that.mainmap.getOverlayById("pipeline_data");
            if(overlay){
                overlay.setPosition(undefined);
            }

            //管线字段说明
            let pipelineProperty={
                designOpen:"设计开度",
                realOpen:"实际开度",
            }
            let itemHtml="";
            for(let itemname in realData){
                if(pipelineProperty[itemname]){
                    itemHtml+="<li class='"+itemname+"'>"+pipelineProperty[itemname]+"："+realData[itemname]+"</li>"
                }
            }
            overlay=that.mainmap.getOverlayById("pipelineproperty");
            let overlayDom=null;
            if(!overlay){
                overlayDom=document.createElement("div");
                overlayDom.className="ztOverlay pipelineproperty property";

                let innerHTML= "<div class='zt-title'>" +
                        '<div class="zt-close"><i class="iconfont">&#xe618;</i></div>'+
                    "</div>"+
                    "<ul class='ztOverlay_content'>"+
                        itemHtml+
                    "</ul>";
                overlayDom.innerHTML=innerHTML;

                overlay =new Overlay({
                    id:"pipelineproperty",
                    element: overlayDom,
                    positioning:"bottom-center",
                    offset:[0,-40],
                    stopEvent:false
                });

                that.mainmap.addOverlay(overlay);
                overlayDom.querySelector(".zt-close").addEventListener("click",function () {
                    // 关闭显示
                    let overlay=that.mainmap.getOverlayById("pipelineproperty");
                    if(overlay){
                        overlay.setPosition(undefined);
                    }
                })
            }
            let overHtml=overlay.getElement();
            overHtml.style.zIndex=110001;
            overHtml.style.display="block";

            overHtml.querySelector(".ztOverlay_content").innerHTML=itemHtml;
            // 获取geom中点位置
            let geom=feature.getGeometry();
            let coordinate=getCenter(geom.getExtent());
            overlay.setPosition(coordinate);
        }
    }
}